import {
  FETCH_PRODUCT_DETAIL,
  FETCH_PRODUCT_ITEMS,
  FETCH_PRODUCT_LOCALTOUR,
  FETCH_PRODUCT_TICKET,
  FETCH_PRODUCT_CAR_RENTAL,
  FETCH_PRODUCT_SIM_WIFI,
  FETCH_PRODUCT_AGENT,
  SET_PRODUCT_SHARE,
  SET_COPY_PRODUCT_POPUP,
  CHECK_PRODUCT_STOCK,
  FETCH_PRODUCT_COST_ESTIMATION,
  INIT_EC_REDUX,
  SET_PRODUCT_LIKE,
  SET_FOOTER_PADDING_BOTTOM,
  FETCH_CREDIT_CARDS,
  FETCH_ORDER_DETAIL,
  FETCH_ORDER_LIST,
  POST_PAY,
  PUT_ORDER_INSUREDS,
  PUT_ORDER_PARTNERS,
  SET_OPTION_INTERSECTING,
  FETCH_CURRENT_TRIP
} from '../actionTypes/ec';

// itinerary ec
import {
  SHOW_EDIT_MODE,
  SHOW_POI_ROUTE,
  SHOW_POI_DETAIL,
  SHOW_NOTE_DETAIL,
  SHOW_ADD_POI,
  RESET_ITINERARY
} from '../actions/action_types';

import {
  generateFormattedPois,
  formatDayHasPoi
} from '../utilities/format_pois_util';

const initState = {
  detail: {
    journal: {},
    product: {},
    order: {},
    item: {},
    trip: {},
    common: {},
    orderList: {
      data: [],
      dataNext: false
    }
  },
  productItems: { items: [], product: { status: 0, note: {} } },
  costEstimation: { currency: '', price_total: 0 },
  checkCode: 0,
  isShowCopyBox: false,
  isShowShareMenu: false,
  cards: [],
  isOptionSectionIntersecting: false,
  // hack see #1103
  isFooterPaddingBottom: false
};

const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_DETAIL.LOADING:
      return initState;
    case FETCH_PRODUCT_DETAIL.SUCCESS:
      return setDetailState(state, action);
    case FETCH_PRODUCT_ITEMS.LOADING:
    case FETCH_PRODUCT_LOCALTOUR.LOADING:
    case FETCH_PRODUCT_TICKET.LOADING:
    case FETCH_PRODUCT_CAR_RENTAL.LOADING:
    case FETCH_PRODUCT_SIM_WIFI.LOADING:
    case FETCH_PRODUCT_AGENT.LOADING:
      return {
        ...state,
        productItems: { items: [], product: { status: 0 } },
        checkCode: 0
      };
    case FETCH_PRODUCT_ITEMS.SUCCESS:
    case FETCH_PRODUCT_LOCALTOUR.SUCCESS:
    case FETCH_PRODUCT_TICKET.SUCCESS:
    case FETCH_PRODUCT_CAR_RENTAL.SUCCESS:
    case FETCH_PRODUCT_SIM_WIFI.SUCCESS:
    case FETCH_PRODUCT_AGENT.SUCCESS:
      return {
        ...state,
        productItems: action.payload.data
      };

    case FETCH_PRODUCT_COST_ESTIMATION.LOADING:
      return {
        ...state,
        costEstimation: { currency: '', price_total: 0 },
        checkCode: 0
      };
    case FETCH_PRODUCT_COST_ESTIMATION.SUCCESS:
      return {
        ...state,
        costEstimation: action.payload.data
      };

    case SET_PRODUCT_SHARE.SHOW:
      return {
        ...state,
        isShowShareMenu: true
      };
    case SET_PRODUCT_SHARE.CLOSE:
      return {
        ...state,
        isShowShareMenu: false
      };
    case SET_COPY_PRODUCT_POPUP.SHOW:
      return {
        ...state,
        isShowCopyBox: true
      };
    case SET_COPY_PRODUCT_POPUP.CLOSE:
      return {
        ...state,
        isShowCopyBox: false
      };
    case SET_PRODUCT_LIKE:
      return {
        ...state,
        detail: {
          ...state.detail,
          product: {
            ...state.detail.product,
            like_counts: action.payload.likeCount,
            is_like: action.payload.isLike
          },
          common: {
            ...state.detail.common,
            like_counts: action.payload.likeCount,
            is_like: action.payload.isLike
          }
        }
      };
    case CHECK_PRODUCT_STOCK.SUCCESS:
      return {
        ...state,
        checkCode: action.payload.code
      };
    case CHECK_PRODUCT_STOCK.FAIL:
      return {
        ...state,
        checkCode: action.payload.code
      };
    case SET_FOOTER_PADDING_BOTTOM:
      return {
        ...state,
        isFooterPaddingBottom: action.payload.isFooterPaddingBottom
      };
    case FETCH_CREDIT_CARDS.SUCCESS:
      return {
        ...state,
        cards: action.payload.cards
      };
    case FETCH_CREDIT_CARDS.FAIL:
      return {
        ...state,
        cards: []
      };
    case POST_PAY.FAIL:
      return {
        ...state,
        checkCode: action.payload.code
      };
    case FETCH_ORDER_LIST.SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          orderList: {
            data: action.payload.data,
            dataNext: action.payload.dataNext
          }
        }
      };
    case FETCH_ORDER_LIST.NEXT:
      return {
        ...state,
        detail: {
          ...state.detail,
          orderList: {
            data: [...state.detail.orderList.data, ...action.payload.data],
            dataNext: action.payload.dataNext
          }
        }
      };

    case FETCH_ORDER_LIST.FAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          orderList: {
            data: [],
            dataNext: false
          }
        }
      };
    case FETCH_ORDER_DETAIL.SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          product: action.payload.product,
          order: action.payload.order,
          item: action.payload.item
        }
      };
    case FETCH_ORDER_DETAIL.FAIL:
      return {
        ...state
      };

    case PUT_ORDER_INSUREDS.SUCCESS:
      return setInsureds(state, action.payload.insureds);
    case PUT_ORDER_INSUREDS.FAIL:
      return {
        ...state
      };

    case PUT_ORDER_PARTNERS.SUCCESS:
    case PUT_ORDER_PARTNERS.FAIL:
      return {
        ...state
      };

    case FETCH_CURRENT_TRIP.LOADING:
      return {
        ...state,
        detail: {
          ...state.detail,
          trip: {}
        }
      };
    case FETCH_CURRENT_TRIP.SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          trip: {
            ...action.payload.results,
            dayWithPois: formatDayHasPoi(action.payload.results)
          }
        }
      };
    case FETCH_CURRENT_TRIP.FAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          trip: {}
        }
      };
    case FETCH_CURRENT_TRIP.INIT:
      return {
        ...state,
        detail: {
          ...state.detail,
          trip: {}
        }
      };

    // product scroll view
    case SET_OPTION_INTERSECTING:
      return {
        ...state,
        isOptionSectionIntersecting: action.payload.isIntersecting
      };

    case INIT_EC_REDUX:
    case SHOW_EDIT_MODE:
    case SHOW_POI_ROUTE:
    case SHOW_POI_DETAIL:
    case SHOW_NOTE_DETAIL:
    case SHOW_ADD_POI:
    case RESET_ITINERARY:
      return initState;
    default:
      return state;
  }
};

/**
 * 2023-01-07
 * Current patched as a Hotfix, clean code is preferred
 * 2020-09-22
 * 目前 detail 內綁 journal ，但日後可能不會有綁 journal 的商品（就單個商品冰淇淋、sim 卡之類）
 * 而綁 journal 的資料格式則比照遊記 journal page 資料格式處理
 */
const setDetailState = (state, action) => {
  // This was new
  if ({}.hasOwnProperty.call(action.payload.data, 'extras'))
    return {
      ...state,
      detail: {
        common: { ...action.payload.data.common },
        product: {
          ...state.detail.product,
          ...action.payload.data.extras.product,
          sections: [...action.payload.data?.sections],
          days: [...action.payload.data?.days]
        }
      }
    };
  // This was new

  if (!action.payload.data.journal)
    return {
      ...state,
      detail: {
        ...action.payload.data
      }
    };

  // 注意下面這段是比照 journal 前人寫法
  // TODO: 優化效能
  const { dayCount, startTime, pois } = action.payload.data;
  const array = pois.map(item => ({ ...item.trip, journal: item.journal }));

  const itinerary = { dayCount, startTime, pois: array };
  const journal = {
    ...action.payload.data.journal,
    formattedPois: generateFormattedPois(itinerary)
  };

  return {
    ...state,
    detail: {
      ...action.payload.data,
      journal
    },
    checkCode: 0
  };
};

const setInsureds = (state, insureds) => {
  if (insureds && insureds.length === 0) return state;
  const newInsureds = [...state.detail.order.insureds];
  insureds.forEach(item => {
    const index = newInsureds.findIndex(item2 => item2.id === item.id);
    newInsureds[index] = item;
  });
  return {
    ...state,
    detail: {
      ...state.detail,
      order: {
        ...state.detail.order,
        insureds: newInsureds
      }
    }
  };
};
